import { Base32 } from "./base32";
import { Crc8 } from "./crc8";

const BSIZE = 12;

export class Xid {
  public static generateId(): string {
    const bytes = this.randomBytes(BSIZE);
    return this.encode(bytes);
  }

  private static randomBytes(n: number): Uint8Array {
    const bits = [];
    if (n > 0) {
      while (n-- > 0) {
        bits.push(~~(Math.random() * 256));
      }
    }
    const ints = new Uint8Array(bits.length);
    for (let i = 0; i < ints.length; i++) {
      ints[i] = bits[i];
    }
    return ints;
  }

  private static encode(bytes: Uint8Array): string {
    const base32 = new Base32();
    return base32.encode(bytes);
  }

  private static decode(xid: string) {
    const base32 = new Base32();
    const bytes = base32.decode(xid);
    const last = bytes.length - 1;
    const calc = Crc8(bytes, 0, last);
    const check = bytes[last];
    if (calc !== check) {
      throw new Error("invalid xid.");
    }
    return bytes;
  }
}
